import { render, staticRenderFns } from "./TeacherForm.vue?vue&type=template&id=1e745adc"
import script from "./TeacherForm.vue?vue&type=script&lang=js"
export * from "./TeacherForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherForm.vue?vue&type=style&index=0&id=1e745adc&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e745adc')) {
      api.createRecord('1e745adc', component.options)
    } else {
      api.reload('1e745adc', component.options)
    }
    module.hot.accept("./TeacherForm.vue?vue&type=template&id=1e745adc", function () {
      api.rerender('1e745adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/TeacherForm.vue"
export default component.exports